<template>
  <v-btn v-if="! filtersConfigs?.length" color="secondary" size="small" icon :loading="filtersSaving" class="ml-1" @click="saveFilter(null)">
    <v-icon>{{ filtersSaved ? 'far fa-check' : 'far fa-save' }}</v-icon>
    <v-tooltip location="bottom">{{ $t('MULTIPROJECTS.SAVE_FILTERS.SAVE') }}</v-tooltip>
  </v-btn>

  <v-btn-group v-else density="comfortable" color="secondary" divided class="ml-1">
    <v-btn size="large" icon :loading="filtersSaving" class="px-2" @click="saveFilter(null)">
      <v-icon class="ml-.5">{{ filtersSaved ? 'far fa-check' : 'far fa-save' }}</v-icon>
      <v-tooltip location="bottom" activator="parent">{{ $t('MULTIPROJECTS.SAVE_FILTERS.SAVE') }}</v-tooltip>
    </v-btn>
    <v-menu location="bottom end">
      <template #activator="{ props }">
        <v-btn size="small" class="pl-1 pr-2" style="min-width: 0" v-bind="props">
          <v-icon>far fa-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list density="compact">
        <v-list-item v-for="(config, index) in filtersConfigs" :key="index" :active="config === selectedConfig" @click="applyConfig(config)">
          <div class="d-flex align-center">
            {{ config.name }}
            <div class="mx-1"></div>
            <v-btn-icon size="x-small" class="ml-auto" @click.stop="saveFilter(config)"><v-icon size="large">far fa-save</v-icon></v-btn-icon>
            <v-btn-icon size="x-small" color="errorred" class="mr-n2" @click.stop="deleteConfig(config)"><v-icon size="large">far fa-trash-alt</v-icon></v-btn-icon>
          </div>
        </v-list-item>
        <v-list-item>
          <v-btn variant="text" block @click="addConfig">{{ $t('MULTIPROJECTS.SAVE_FILTERS.NEW_CONFIG') }}</v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-btn-group>
</template>

<script>
  import useMultiprojectsStore from '@/stores/multiprojects/multiprojects';
  import useUserOptionsStore from '@/stores/user-options';

  export default {
    data() {
      return {
        filtersSaving: false,
        filtersSaved: false,
        selectedConfig: null,
        multiprojectsStore: useMultiprojectsStore(),
        userOptionsStore: useUserOptionsStore(),
      };
    },
    computed: {
      dashboardName() {
        return this.$route.path.slice(1).replace(/\//g, '_');
      },
      filtersConfigs() {
        return this.userOptionsStore.getOption(`dashfilters-${this.dashboardName}`);
      },
    },
    created() {
      if (this.filtersConfigs?.length) [this.selectedConfig] = this.filtersConfigs;
    },
    methods: {
      saveFilter(paramConfig = null) { // config not provided when pushing main save button -> use last selected config or default
        if (! this.filtersConfigs) {
          this.userOptionsStore.setOption(`dashfilters-${this.dashboardName}`, []);
        }
        const config = paramConfig || this.selectedConfig;
        const index = config ? this.filtersConfigs.indexOf(config) : 0;
        if (index == -1) return;
        let name = this.filtersConfigs[index]?.name || this.$t('MULTIPROJECTS.SAVE_FILTERS.DEFAULT');
        // eslint-disable-next-line no-alert
        if (paramConfig || this.filtersConfigs.length > 1) name = prompt(this.$t('MULTIPROJECTS.SAVE_FILTERS.CONFIG_NAME'), name);
        if (! name) return;
        this.filtersSaving = true;
        this.filtersConfigs[index] = { name, ...this.multiprojectsStore.getCurrentFiltersConfig() }; // set current config
        this.selectedConfig = this.filtersConfigs[index];
        this.multiprojectsStore.saveFilters(this.dashboardName).then(() => { // save to db
          this.filtersSaving = false;
          this.filtersSaved = true;
          setTimeout(() => { this.filtersSaved = false; }, 5000);
        });
      },
      applyConfig(config) {
        this.multiprojectsStore.applyFiltersConfig(config);
        const filtersSelections = this.multiprojectsStore.cleanSelectedFilters();
        this.multiprojectsStore.$patch((state) => {
          state.selectedCompanyUsers = filtersSelections.selectedCompanyUsers;
          state.selectedCompanyGroups = filtersSelections.selectedCompanyGroups;
          state.selectedProjects = filtersSelections.selectedProjects;
          state.selectedVirtualParticipants = filtersSelections.selectedVirtualParticipants;
          state.selectedDeletedUsers = filtersSelections.selectedDeletedUsers;
          state.selectedActionVirtualParticipants = filtersSelections.selectedActionVirtualParticipants;
          state.selectedActionDeletedUsers = filtersSelections.selectedActionDeletedUsers;
        });
        this.selectedConfig = config;
      },
      addConfig() {
        // eslint-disable-next-line no-alert
        const name = prompt(this.$t('MULTIPROJECTS.SAVE_FILTERS.CONFIG_NAME'));
        if (! name) return;
        this.filtersSaving = true;
        this.filtersConfigs.push({ name, ...this.multiprojectsStore.getCurrentFiltersConfig() });
        this.selectedConfig = this.filtersConfigs[this.filtersConfigs.length - 1];
        this.multiprojectsStore.saveFilters(this.dashboardName).then(() => {
          this.filtersSaving = false;
          this.filtersSaved = true;
          setTimeout(() => { this.filtersSaved = false; }, 5000);
        });
      },
      deleteConfig(config) {
        const index = this.filtersConfigs.indexOf(config);
        if (index == -1) return;
        if (this.selectedConfig == config) this.selectedConfig = null;
        this.filtersConfigs.splice(index, 1);
        this.multiprojectsStore.saveFilters(this.dashboardName);
      },
    },
  };
</script>
